export default "__VITE_ASSET__pNYedmGh__"